<template>
  <div>
    <div class="row no-gutter">
      <div>
        <div 
          :class="{'invalid':errors.has('name')}" 
          class="md-form-group">
          <input 
            v-validate="'required'" 
            :disabled="loading" 
            v-model="formData.name" 
            placeholder="Required" 
            name="name" 
            class="md-input">
          <label>Name</label>
          <span 
            v-show="errors.has('name')" 
            class="form-error-msg">{{ errors.first('name') }}</span>
        </div>

        <div 
          :class="{'invalid':errors.has('email')}" 
          class="md-form-group">
          <input 
            v-validate="'email'" 
            :disabled="loading" 
            v-model="formData.email" 
            placeholder="Optional - But must be unique" 
            name="email" 
            class="md-input">
          <label>Email</label>
          <span 
            v-show="errors.has('email')" 
            class="form-error-msg">{{ errors.first('email') }}</span>
        </div>

        <div 
          :class="{'invalid':errors.has('pin')}" 
          class="md-form-group">
          <input 
            v-validate="'required'" 
            :disabled="loading" 
            v-model="formData.pin" 
            placeholder="Required and must be unique" 
            name="pin" 
            class="md-input">
          <label>Pin</label>
          <span 
            v-show="errors.has('pin')" 
            class="form-error-msg">{{ errors.first('pin') }}</span>
        </div>

        <div 
          :class="{'invalid':errors.has('rf_id')}" 
          class="md-form-group">
          <input 
            :disabled="loading" 
            v-model="formData.rf_id" 
            placeholder="Optional - But must be unique" 
            name="rf_id" 
            class="md-input" 
            data-vv-as="card ID">
          <label>Card ID</label>
          <span 
            v-show="errors.has('rf_id')" 
            class="form-error-msg">{{ errors.first('rf_id') }}</span>
        </div>

        <div class="md-form-group">
          <select
            :disabled="loading"
            v-model="formData.outlet_id"
            class="md-input">
            <option
              v-if="canAccessAllOutlets"
              value="0">Available in all outlets</option>
            <option 
              v-for="outlet in outlets" 
              :value="outlet.id" 
              :key="outlet.id">
              {{ outlet.name }}
            </option>
          </select>
          <label for="pricing">Outlet</label>
        </div>
      </div>
    </div>

    <div class="row no-gutter">
      <div>
        <p>Permissions</p>
        <div class="form-group">
          <label class="typo__label multiselect-label">Assign permissions</label>
          <multiselect 
            v-model="formData.permissions" 
            :disabled="loading" 
            :options="permissions" 
            :multiple="true"
            :close-on-select="false"
            :hide-selected="true" 
            :max-height="170" 
            :limit="10" 
            label="display_name"
            track-by="name"
            placeholder="Select permission"
            select-label="Select"/>
        </div>
      </div>
    </div>

    <div class="row no-gutter">
      <div>
        <p>Roles</p>
        <div class="form-group">
          <label class="typo__label multiselect-label">Assign roles</label>
          <multiselect 
            v-model="formData.roles" 
            :disabled="loading" 
            :options="roles" 
            :multiple="true"
            :close-on-select="false"
            :hide-selected="true" 
            :max-height="170" 
            :limit="10" 
            label="display_name"
            track-by="name"
            placeholder="Select roles"
            select-label="Select"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthMixin from '@js/mixins/auth';
import Vue from 'vue';

export default {
    mixins: [AuthMixin],

    props: {
        staff: {
            required: true,
            type: Object,
        },
    },

    data() {
        return {
            formData: null,
            outlets: [],
            permissions: [],
            roles: [],
            loading: false,
        };
    },

    watch: {
        staff() {
            var vm = this;
            this.setFormData();
            setTimeout(() => {
                vm.errors.clear();
            }, 100);
        },
    },

    created() {
        this.setFormData();
        this.getOutletList();
        this.getRolesAndPermissions();
    },

    methods: {
        getSubmiitedValue() {
            return {
                name: this.formData.name,
                pin: this.formData.pin,
                email: this.formData.email,
                rf_id: this.formData.rf_id,
                roles: this.formData.roles.map(obj => obj.name),
                outlet_id: this.formData.outlet_id,
                permissions: this.formData.permissions.map(obj => obj.name),
            };
        },

        setFormData() {
            if (this.staff.outlet_id === null) {
                this.staff.outlet_id = this.firstAvailableOutlet;
            }

            this.formData = Vue.util.extend({}, this.staff);
        },

        submit() {
            this.$emit('beforeSubmit');

            if (!this.loading) {
                let that = this;

                this.loading = true;
                this.$validator.validateAll().then(success => {
                    if (!success) {
                        this.loading = false;
                        this.$emit('submitFailed');
                        return;
                    }

                    let api = this.getSubmitApi();
                    this.$http[this.getSubmitMethod()](
                        api,
                        this.getSubmiitedValue(),
                    ).then(
                        res => {
                            let data = res.data.data;
                            this.loading = false;

                            if (data.outlet_id === null) {
                                data.outlet_id = 0;
                            }

                            this.$emit('submitSuccess', data);
                        },
                        err => {
                            if (err.response.status !== 422) {
                                toastr.error(err.response.statusText);
                            }

                            this.processLaravelErrors(
                                that.$validator,
                                err.response,
                            );
                            this.loading = false;
                            this.$emit('submitFailed');
                        },
                    );
                });
            }
        },

        staffExist() {
            return this.staff.id != 0 && this.staff.id != undefined;
        },

        getSubmitMethod() {
            if (this.staffExist()) {
                return 'patch';
            } else {
                return 'post';
            }
        },

        getSubmitApi() {
            if (this.staffExist()) {
                return Laroute.route('franchise.staff.update', {
                    id: this.staff.id,
                });
            } else {
                return Laroute.route('franchise.staff.store');
            }
        },

        getRolesAndPermissions() {
            let api = Laroute.route('franchise.staff.getRolesAndPermissions');
            this.$http.get(api).then(res => {
                let data = res.data.data;
                this.roles = data.roles;
                this.permissions = data.permissions;
            });
        },

        getOutletList() {
            let api = Laroute.route('franchise.vue.outlets');

            this.$http.get(api).then(response => {
                let data = response.data.data;
                this.outlets = data;
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/outlet/staff/_form.vue